import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL;

export default function Login() {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/api/auth/login`, { email: identifier, password });
      const { access_token, must_change_password } = res.data;
      const { user_type, email: userEmail, name } = res.data.user;
      login(access_token, { email: userEmail, user_type, name, must_change_password: !!must_change_password });
      if (user_type === 'admin') navigate('/admin');
      else if (user_type === 'mfd') navigate(must_change_password ? '/mfd/change-password' : '/mfd');
      else navigate('/retail');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.logo}>FIP</div>
          <h1 style={styles.title}>Fund Intelligence Platform</h1>
          <p style={styles.subtitle}>Sign in to your account</p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}
          <div style={styles.field}>
            <label style={styles.label}>Email or MFD Code</label>
            <input type="text" value={identifier} onChange={e => setIdentifier(e.target.value)}
              style={styles.input} placeholder="Email or MFD Code (e.g. RMF001)" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <div style={styles.pwdWrapper}>
              <input type={showPwd ? 'text' : 'password'} value={password}
                onChange={e => setPassword(e.target.value)}
                style={styles.pwdInput} placeholder="Enter your password" required />
              <button type="button" onClick={() => setShowPwd(v => !v)} style={styles.eyeBtn} tabIndex={-1}>
                {showPwd ? '🙈' : '👁️'}
              </button>
            </div>
          </div>
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={styles.forgotLink}>
          <button type="button" onClick={() => navigate('/mfd/forgot-password')} style={styles.forgotBtn}>
            Forgot password? (MFD)
          </button>
        </p>
        <p style={styles.footer}>Fund Intelligence Platform © 2026</p>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Segoe UI', sans-serif" },
  card: { background: '#fff', borderRadius: '12px', padding: '48px 40px', width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  header: { textAlign: 'center', marginBottom: '32px' },
  logo: { background: '#1565C0', color: '#fff', width: '56px', height: '56px', borderRadius: '12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', marginBottom: '16px' },
  title: { fontSize: '22px', color: '#1565C0', margin: '0 0 8px', fontWeight: '700' },
  subtitle: { color: '#666', margin: 0, fontSize: '14px' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#333' },
  input: { padding: '12px 14px', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none' },
  pwdWrapper: { display: 'flex', alignItems: 'center', border: '1.5px solid #ddd', borderRadius: '8px', overflow: 'hidden' },
  pwdInput: { flex: 1, padding: '12px 14px', border: 'none', fontSize: '14px', outline: 'none' },
  eyeBtn: { background: 'none', border: 'none', padding: '0 12px', cursor: 'pointer', fontSize: '16px' },
  button: { background: '#1565C0', color: '#fff', border: 'none', borderRadius: '8px', padding: '14px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  error: { background: '#ffebee', color: '#CC0000', padding: '12px', borderRadius: '8px', fontSize: '13px', border: '1px solid #ffcdd2' },
  footer: { textAlign: 'center', color: '#aaa', fontSize: '12px', marginTop: '24px' },
  forgotLink: { textAlign: 'center', margin: '16px 0 0' },
  forgotBtn: { background: 'none', border: 'none', color: '#1565C0', fontSize: '13px', cursor: 'pointer', padding: 0, textDecoration: 'underline' },
};
